import { gsap } from "gsap";
import { debounce, checkCart } from "../helpers";

class CartItems extends HTMLElement {

	static formAssociated = true;

	constructor() {

		super();

		this.internals_ = this.attachInternals();
		this.form = this.closest("cart-wrapper");
		this.overlay = this.form.querySelector(`#${this.dataset.section}_screen`);

		gsap.set(this.overlay, { autoAlpha: 0 });

		this.overlay?.classList.remove("hidden");

		this.addEventListener("change", debounce(event => this.onChange(event)).bind(this));
	}

	onChange(event) {

		// TODO: Line index changes if index "1" removes when index "2" remains

		this.updateQuantity(event.target.closest("[data-index]").dataset.index, event.target.value, event.target.name, event.target);
	}

	updateQuantity(line, value, name = null, el = null) {

		/** Do not allow users to add more than X to cart */
		if (name == "quantity" && parseInt(value) > parseInt(el.max)) {

			el.value = el.max;

			return;
		}

		/** Update object */
		let pass = {};
		let cartChange = false;

		pass.line = line;

		/** Pass selling plan ID */
		if (name == "selling_plan_update") {

			let sellingPlanEl = this.querySelector("[name='selling_plan']");
			let quantity = this.querySelector("[name='quantity']");

			pass.selling_plan = (el.checked) ? sellingPlanEl.value : null;
			pass.quantity = quantity.value;

			/** Update line pricing */
			cartChange = true;

			/** Show processing overlay */
			gsap.to(this.overlay, { autoAlpha: 1, duration: 0.15 });

		} else {

			/** Pass quantity */
			pass[name] = parseInt(value);
		}

		const data = JSON.stringify(pass);

		/** Let's remove the line item if quantity is 0 */
		if (name == "quantity" && value <= 0 && el) el.remove();

		fetch(`${window.routes.cart_change_url}`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json"
			},
			body: data
		})
			.then(response => response.text())
			.then((state) => {

				const json = JSON.parse(state);

				let getPrice = 0;
				let getDiscount = 0;
				let getCount = 0;

				[...json.items].forEach((item) => {

					if (item.product_title.toLowerCase() == "build a box" || item.handle == "build-a-box") {

						let boxKey = item.properties._box_key;
						let boxDiscount = (item.properties._discount) ? (100 - parseFloat(item.properties._discount)) / 100 : 1;
						let priceTotal = 0;
						let discountTotal = 0;

						[...json.items].forEach((prod) => {

							if (prod.properties._box_key == boxKey) {

								let thisPrice = prod.line_price * boxDiscount;


								priceTotal += thisPrice;
								discountTotal += (prod.line_price - thisPrice);
							}
						});

						getPrice += priceTotal;
						getDiscount += discountTotal;
						getCount += item.quantity;

					} else {

						let type = item.product_type.toLowerCase();

						if (type.indexOf("pouch") === -1 && type.indexOf("single") === -1) {

							getPrice += item.line_price;

							if (item.line_level_total_discount > 0) {
								getDiscount += item.line_level_total_discount;
							} else if (item.selling_plan_allocation?.compare_at_price) {
								getDiscount += (item.selling_plan_allocation.compare_at_price - item.line_price);
							}

							getCount += item.quantity;
						}
					}
				});

				/** Called individually in order to not interfere with the Proxy */
				if (window.Zero.Cart.stats.discount !== getDiscount) window.Zero.Cart.stats.discount = getDiscount;
				if (window.Zero.Cart.stats.subtotal !== getPrice) window.Zero.Cart.stats.subtotal = getPrice;
				if (window.Zero.Cart.stats.total !== json.total_price) window.Zero.Cart.stats.total = json.total_price;
				if (window.Zero.Cart.stats.count !== getCount) {
					window.Zero.Cart.stats.count = getCount;
					/** Send cart event that can be listened to **/
					document.dispatchEvent(
						new CustomEvent("cartChange", { detail: window.Zero.Cart })
					);
				}


				/** Show empty form */
				if (json.item_count <= 0) {

					this.form.displayEmpty();

					return;
				}

				/** Subscription swap cart update DOM */
				if (cartChange && cartChange === true) {
					fetch(`${window.Shopify.routes.root}cart?section_id=${this.dataset.section}`, {
						method: "GET"
					})
						.then((response) => response.text())
						.then((responseText) => {

							const html = new DOMParser().parseFromString(responseText, "text/html");
							const section = html.getElementById(`${this.dataset.section}_lines`);

							this.form.querySelector(`#${this.dataset.section}_lines`).innerHTML = section.innerHTML;

							window.Zero.lazyLoad.update();

							/** Hide processing overlay */
							gsap.to(this.overlay, { autoAlpha: 0, duration: 0.15 });
						})
						.catch((e) => {
							console.error(e);

							/** Hide processing overlay */
							gsap.to(this.overlay, { autoAlpha: 0, duration: 0.15 });
						});
				}
			})
			.catch((e) => {
				console.error(e);

				/** Hide processing overlay */
				gsap.to(this.overlay, { autoAlpha: 0, duration: 0.15 });
			});
	}

	multiRemove(indices, parent) {

		let data = {
			updates: {}
		};

		[...indices].forEach((idx) => {

			if (!idx) return;

			let index = idx.toString();

			data.updates[index] = 0;
		});

		let url = window.Shopify.routes.root + "cart/update.js"

		fetch(url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json"
			},
			body: JSON.stringify(data)
		})
			.then(response => response.text())
			.then((state) => {

				const json = JSON.parse(state);
				console.log("🚀 ~ CartItems ~ json", json)

				/* window.Zero.Cart.stats.count = json.item_count;
				window.Zero.Cart.stats.discount = json.total_discount;
				window.Zero.Cart.stats.subtotal = json.items_subtotal_price;
				window.Zero.Cart.stats.total = json.total_price; */

				/** Show empty form */
				if (json.item_count <= 0) {

					this.form.displayEmpty();

					return;
				}

				checkCart()
			})
			.catch((e) => {
				console.error(e);

				/** Hide processing overlay */
				gsap.to(this.overlay, { autoAlpha: 0, duration: 0.15 });
			});
	}
}

export default CartItems;
